import { apiInstances } from '../../../../libs';

const { post } = apiInstances.authInstance;

export default function verifyCustomToken(payload) {
  return post('/password/validate-token/clouder', payload, {
    headers: {
      Authorization: `Bearer ${payload?.token}`,
    },
    _ignoreReload: true,
  });
}
